import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './StatusBadge.module.scss'

const propTypes = {
  /**
   * Content of the badge
   */
  children: PropTypes.node.isRequired,
  /**
   * Color variant of the badge
   */
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'info', 'secondary']),
  /**
   * Additional CSS class
   */
  className: PropTypes.string,
  /**
   * Custom left margin for alignment
   */
  marginLeft: PropTypes.string,
}

function StatusBadge(props) {
  const { children, variant = 'secondary', className = '', marginLeft = undefined } = props ?? {}

  return (
    <span
      className={clsx(styles.badge, styles[variant], className)}
      style={{
        ...(marginLeft && { marginLeft }),
      }}
    >
      {children}
    </span>
  )
}

StatusBadge.propTypes = propTypes

export default StatusBadge
